import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesDashboard } from "../../constants";
import { SocialSourcesResponse } from "./socialSources.types";

export const requestSocialSources =
  async (): Promise<SocialSourcesResponse> => {
    return await instance.get(buildUrl(ApiRoutesDashboard.SocialSources));
  };
